export const liveIndicatorStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  color: 'text.secondary',
};

export const liveDotStyles = {
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: 'success.main',
};

export const headerActionsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const tableCellStyles = {
  padding: 0,

  '& .table-cell__content_box': {
    overflow: 'visible',
  },
};

export const signerTableWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: '18px',
  alignItems: 'flex-end',
};

// The package list is a headerless card stack: hide the outer table's own
// header row (its columns are spanned by each package accordion) while keeping
// the inner per-signer table headers, which live inside a table body.
export const packageTableStyles = {
  '& .MuiTableHead-root': {
    display: 'none',
  },
  '& .MuiTableBody-root .MuiTableHead-root': {
    display: 'table-header-group',
  },
};
